function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "647.6189mm",
    height: "200mm",
    viewBox: "0 0 647.6189 200",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m-21.79 108.524-23.276 130.362H1.597l23.24-130.362zM40.932 108.524l-6.224 34.856h56.865l-73.918 95.506h53.036l40.255-52.028-9.281 52.028h46.626l11.639-65.163H121.11l50.458-65.199zM-37.884 108.524h-52.999l26.96-34.819h-52.998l-50.457 65.163h53.035l-77.417 100.018h53.035l40.256-52.028-9.281 52.028h46.626l11.638-65.163h-38.819zM187.663 108.524l-23.276 130.362h46.626l23.277-130.362zM250.348 108.524l-6.188 34.856h56.534l-73.586 95.506h52.999l39.776-51.628-9.208 51.628h46.664l11.638-65.163h-38.634l50.235-65.199zM425.695 204.031l17.053-95.507H396.12l-23.277 130.362h30.164l-6.224 34.82h46.664l12.411-69.675z",
    style: {
      fill: "#00ffa3",
      fillOpacity: 1,
      strokeWidth: 9.5238
    },
    transform: "translate(191.76 -73.705)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.378028c14cf4b820b1022457fb63db18.svg";
export { ForwardRef as ReactComponent };